module.exports = __webpack_public_path__ + "static/media/calendar3.b026a56d.svg";